import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0588ea1c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "ShortcomingFiles"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ShortcomingFiles__title" }, "АКТ ОБ ОБНАРУЖЕНИИ НЕДОСТАТКОВ", -1))
const _hoisted_3 = { class: "mt-5" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Кто загрузил:", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_uploaded_file = _resolveComponent("uploaded-file")!

  return (_ctx.isShortcomingFiles)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "ShortcomingFiles__header",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleShortcomingFiles && _ctx.toggleShortcomingFiles(...args)))
        }, [
          _hoisted_2,
          _createElementVNode("i", {
            class: _normalizeClass(_ctx.getClass)
          }, null, 2)
        ]),
        _createVNode(_Transition, null, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", null, [
              _createElementVNode("p", _hoisted_3, [
                _hoisted_4,
                _createTextVNode(" " + _toDisplayString(_ctx.userEmail), 1)
              ]),
              _createVNode(_component_uploaded_file, {
                "is-visible": _ctx.isReportFiles,
                files: _ctx.state.shortcoming_report_files,
                title: "Акт об обнаружении недостатков",
                class: "my-5",
                "no-delete": ""
              }, null, 8, ["is-visible", "files"]),
              _createVNode(_component_uploaded_file, {
                "is-visible": _ctx.isProductFiles,
                files: _ctx.state.shortcoming_product_files,
                title: "Фото товаров акта об обнаружении недостатков",
                class: "my-5",
                "no-delete": ""
              }, null, 8, ["is-visible", "files"])
            ], 512), [
              [_vShow, _ctx.state.is_visible]
            ])
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}